import { IApplicationState } from 'setup/store'

export const selectLanguage = (state: IApplicationState) => state.userSettings.data.lang
export const selectLanguageChanged = (state: IApplicationState) => state.userSettings.data.isChanged
export const selectDirection = (state: IApplicationState) => state.userSettings.data.direction

// export const selectOddType = (state: IApplicationState) => state.userSettings.data.oddType
